<template>
  <dialog-add
    :title="$t('terms_and_conditions')"
    is-fullscreen
    :is-on="true"
    :on-close="onClose"
  >
    <template v-slot:content>
      <TermsContent />
    </template>
  </dialog-add>
</template>

<script>
import TermsContent from './Index.vue';

export default {
  components: { TermsContent },
  methods: {
    onClose() {
      this.$router.back();
    },
  },
};
</script>
